//Service for saving stuff in localstorage with expiry

const Storage = {
    setWithExpiry: (key, value, ttl) => {
        const now = new Date()

        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        if (typeof window !== 'undefined') localStorage.setItem(key, JSON.stringify(item))
    },

    getWithExpiry: (key) => {
        const itemStr = (typeof window !== 'undefined') ? localStorage.getItem(key) : null;

        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }

        const item = JSON.parse(itemStr)
        const now = new Date()
        // compare the expiry time of the item with the current time
        const hardExpiry = 1669111097000 //item.expiry
        if (now.getTime() > item.expiry) {

            // If the item is expired, delete the item from storage
            // and return null
            if (typeof window !== 'undefined') localStorage.removeItem(key)
            return null
        }
        return item.value
    },

    // Set status of the notice bar
    setNoticeStatus: () => {
        if (typeof window !== 'undefined') sessionStorage.setItem('notice-closed', true);
    },

    // Get status of the notice bar
    getNoticeStatus: () => {
        if (typeof window !== 'undefined') {
            return sessionStorage.getItem('notice-closed');
        }
    }
}

export default Storage